import React from 'react'

/** Señales lejanas en el campo — pocas, discretas (no “navidad”) */
const FIELD_LIGHTS = [
  { top: '62%', left: '14%', size: 4, delay: '0s', duration: '5.2s' },
  { top: '70%', left: '76%', size: 3.5, delay: '1.6s', duration: '6.4s' },
  { top: '54%', left: '86%', size: 3.5, delay: '3.1s', duration: '5.8s' },
  { top: '82%', left: '42%', size: 3, delay: '2.2s', duration: '7s' }
]

/**
 * Decoración del panel de marca: torre de control con faro y haz giratorio.
 * Anclada fuera del bloque de texto (derecha / abajo).
 */
export default function LoginBrandArt({ className = '' }) {
  return (
    <div className={`login-tower ${className}`.trim()} aria-hidden="true">
      {/* Solo el haz gira en CSS; el núcleo del faro vive en el SVG (mismo cx/cy). */}
      <div className="login-tower-pivot">
        <div className="login-tower-beam-wrap">
          <div className="login-tower-beam" />
        </div>
      </div>

      <div className="login-tower-lights">
        {FIELD_LIGHTS.map((light) => (
          <span
            key={`${light.top}-${light.left}`}
            className="login-tower-light"
            style={{
              top: light.top,
              left: light.left,
              width: light.size,
              height: light.size,
              animationDelay: light.delay,
              animationDuration: light.duration
            }}
          />
        ))}
      </div>

      <svg
        className="login-tower-svg"
        viewBox="0 0 240 340"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
      >
        <defs>
          <linearGradient id="loginTowerShaft" x1="120" y1="150" x2="120" y2="300" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#ffffff" stopOpacity="0.28" />
            <stop offset="100%" stopColor="#ffffff" stopOpacity="0.1" />
          </linearGradient>
          <linearGradient id="loginTowerCab" x1="120" y1="92" x2="120" y2="158" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#d8e6f2" stopOpacity="0.42" />
            <stop offset="55%" stopColor="#9bb6cc" stopOpacity="0.28" />
            <stop offset="100%" stopColor="#6f93ad" stopOpacity="0.22" />
          </linearGradient>
          <linearGradient id="loginTowerRoof" x1="120" y1="78" x2="120" y2="98" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#ff9a4a" />
            <stop offset="100%" stopColor="#e86a12" />
          </linearGradient>
          <linearGradient id="loginTowerGlass" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#ffffff" stopOpacity="0.38" />
            <stop offset="100%" stopColor="#ffffff" stopOpacity="0.08" />
          </linearGradient>
          <radialGradient id="loginTowerPad" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#ffffff" stopOpacity="0.14" />
            <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
          </radialGradient>
          <radialGradient id="loginTowerBeaconCore" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#ffe0b5" />
            <stop offset="45%" stopColor="#f4791f" />
            <stop offset="100%" stopColor="#d9631a" />
          </radialGradient>
          <radialGradient id="loginTowerBeaconGlow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#f4791f" stopOpacity="0.55" />
            <stop offset="55%" stopColor="#f4791f" stopOpacity="0.18" />
            <stop offset="100%" stopColor="#f4791f" stopOpacity="0" />
          </radialGradient>
        </defs>

        <ellipse cx="120" cy="308" rx="88" ry="14" fill="url(#loginTowerPad)" />

        <path
          d="M104 300 L110 158 H130 L136 300 Z"
          fill="url(#loginTowerShaft)"
          stroke="rgba(255,255,255,0.34)"
          strokeWidth="1.25"
          strokeLinejoin="round"
        />

        <path
          d="M92 158 H148 L152 170 H88 Z"
          fill="rgba(255,255,255,0.22)"
          stroke="rgba(255,255,255,0.4)"
          strokeWidth="1.2"
          strokeLinejoin="round"
        />

        <path
          d="M78 158 L62 104 H178 L162 158 Z"
          fill="url(#loginTowerCab)"
          stroke="rgba(255,255,255,0.55)"
          strokeWidth="1.6"
          strokeLinejoin="round"
        />

        <g opacity="0.9">
          <rect x="74" y="112" width="16" height="36" rx="2" fill="url(#loginTowerGlass)" />
          <rect x="96" y="110" width="18" height="40" rx="2" fill="url(#loginTowerGlass)" />
          <rect x="120" y="110" width="18" height="40" rx="2" fill="url(#loginTowerGlass)" />
          <rect x="144" y="112" width="16" height="36" rx="2" fill="url(#loginTowerGlass)" />
        </g>

        <path
          d="M70 158 H170"
          stroke="rgba(255,255,255,0.35)"
          strokeWidth="2"
          strokeLinecap="round"
        />

        <path
          d="M74 104 H166 L160 88 H80 Z"
          fill="url(#loginTowerRoof)"
          stroke="rgba(255,210,160,0.85)"
          strokeWidth="1.2"
          strokeLinejoin="round"
        />

        <path
          d="M120 88 V46"
          stroke="rgba(255,255,255,0.72)"
          strokeWidth="2.4"
          strokeLinecap="round"
        />
        <path
          d="M108 60 H132"
          stroke="rgba(255,255,255,0.4)"
          strokeWidth="1.8"
          strokeLinecap="round"
        />

        {/* Faro: glow + núcleo + anillo, todos en (120, 40) */}
        <g className="login-tower-beacon-svg">
          <circle className="login-tower-beacon-glow" cx="120" cy="40" r="18" fill="url(#loginTowerBeaconGlow)" />
          <circle className="login-tower-beacon-core" cx="120" cy="40" r="5.5" fill="url(#loginTowerBeaconCore)" />
          <circle cx="120" cy="40" r="10" stroke="rgba(255,210,160,0.75)" strokeWidth="1.5" fill="none" />
        </g>
      </svg>
    </div>
  )
}
